export enum RccapTargetReport {    
    Both = 0,
    Coordinators = 1,
    LabDirectors = 2
}